
(() => {
  if (window.sealedCheckInitialized) return;
  window.sealedCheckInitialized = true;

  const variantId = 54563252306261;
  const root = window.Shopify?.routes?.root || '/';

  let busy = false;
  let syncVersion = 0;

  async function getCart() {
    const response = await fetch(root + 'cart.js', {
      cache: 'no-store'
    });

    if (!response.ok) {
      throw new Error('Cart unavailable');
    }

    return response.json();
  }

  function hasSealedCheck(cart) {
    return cart.items.some(
      item => Number(item.variant_id) === variantId
    );
  }

  async function syncSwitch() {
    if (busy) return;

    const version = ++syncVersion;

    try {
      const cart = await getCart();

      if (version !== syncVersion || busy) return;

      const checked = hasSealedCheck(cart);

      document.querySelectorAll(
        '.sealed-check__input'
      ).forEach(input => {
        input.checked = checked;
      });
    } catch (error) {
      console.error('Sealed Check sync:', error);
    }
  }

  document.addEventListener('change', async (event) => {
    const input = event.target.closest(
      '.sealed-check__input'
    );

    if (!input || busy) return;

    const wanted = input.checked;
    busy = true;
    ++syncVersion;
    input.disabled = true;

    try {
      const cart = await getCart();

      const existing = cart.items.find(
        item => Number(item.variant_id) === variantId
      );

      if (wanted && !existing) {
        const response = await fetch(root + 'cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            items: [{
              id: variantId,
              quantity: 1
            }]
          })
        });

        if (!response.ok) {
          throw new Error('Add failed');
        }
      }

      if (!wanted && existing) {
        const response = await fetch(root + 'cart/change.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            id: existing.key,
            quantity: 0
          })
        });

        if (!response.ok) {
          throw new Error('Remove failed');
        }
      }

      const drawer = document.querySelector('cart-drawer');

      if (drawer && typeof drawer.refresh === 'function') {
        await drawer.refresh(true);
      } else {
        window.location.reload();
      }
    } catch (error) {
      console.error('Sealed Check:', error);
      input.checked = !wanted;

      alert(
        'Die Versiegelungsprüfung konnte nicht aktualisiert werden.'
      );
    } finally {
      busy = false;
      input.disabled = false;
      await syncSwitch();
    }
  });

  // Auf Änderungen am Cart Drawer reagieren
  let syncTimer;

  const observer = new MutationObserver(() => {
    if (busy) return;

    clearTimeout(syncTimer);

    syncTimer = setTimeout(() => {
      syncSwitch();
    }, 250);
  });

  const drawer = document.querySelector('cart-drawer');

  if (drawer) {
    observer.observe(drawer, {
      childList: true,
      subtree: true
    });
  }

  // Zustand beim Öffnen oder erneuten Laden prüfen
  document.addEventListener('click', (event) => {
    if (
      event.target.closest(
        'cart-drawer, [aria-controls="cart-drawer"]'
      )
    ) {
      setTimeout(syncSwitch, 400);
    }
  });

  syncSwitch();
})();
